module.exports = __webpack_public_path__ + "static/media/chih_yao_lee.eaca4099.jpg";